module.exports = __webpack_public_path__ + "static/media/cyber.bd25fdf9.png";